import { render, staticRenderFns } from "./Production.vue?vue&type=template&id=398c700c&scoped=true"
import script from "./Production.vue?vue&type=script&lang=js"
export * from "./Production.vue?vue&type=script&lang=js"
import style0 from "../../scss/grid.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Production.vue?vue&type=style&index=1&id=398c700c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c700c",
  null
  
)

export default component.exports